import { useState } from "react";
import Header from "./components/Header";
import Questions from "./components/Questions";
import WelcomeScreen from "./components/WelcomeScreen";
import { reactQuizQuestions } from "./reatQuizQuestions";

import NextButton from "./components/NextButton";
import EndScreen from "./components/EndScreen";
import Timer from "./components/Timer";
import "./App.css";
const SEC = 20;
function App() {
  const [questionsReady, setQuestionsReady] = useState(false);
  const [questionNumber, setQuestionNumber] = useState(0);
  const [answered, setAnswered] = useState(null);
  const [userPoints, setUserPoints] = useState(0);
  const totalQuestions = reactQuizQuestions.length;
  const initialSeconds = totalQuestions * SEC;
  const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds);

  const handleRestart = () => {
    setQuestionsReady(false);
    setQuestionNumber(0);
    setAnswered(null);
    setUserPoints(0);
  };

  const handleSetUserPoints = (points) => {
    setUserPoints((prev) => prev + points);
  };

  const totalScore = reactQuizQuestions.reduce(
    (prev, cur) => prev + cur.points,
    0
  );

  return (
    <div className="App">
      <Header />

      <main className="main ">
        {!questionsReady && (
          <WelcomeScreen
            setQuestionsReady={setQuestionsReady}
            totalQuestions={totalQuestions}
          />
        )}

        {questionsReady && questionNumber <= 14 && (
          <Questions
            questions={reactQuizQuestions[questionNumber]}
            setAnswered={setAnswered}
            answered={answered}
            totalScore={totalScore}
            handleSetUserPoints={handleSetUserPoints}
            userPoints={userPoints}
            questionNumber={questionNumber}
            totalQuestions={totalQuestions}
          />
        )}
        <footer>
          <div>
            {questionsReady && questionNumber < 15 ? (
              <Timer
                secondsRemaining={secondsRemaining}
                setSecondsRemaining={setSecondsRemaining}
              />
            ) : (
              ""
            )}
          </div>
          <div>
            {questionsReady && answered !== null && (
              <NextButton
                setQuestionNumber={setQuestionNumber}
                setAnswered={setAnswered}
              />
            )}
          </div>
        </footer>

        {questionNumber === 15 && (
          <EndScreen
            userPoints={userPoints}
            totalScore={totalScore}
            handleRestart={handleRestart}
          />
        )}
      </main>
    </div>
  );
}

export default App;
